import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAdminAuth } from '../hooks/useAdminAuth';

/**
 * Client-side gate for /admin/dashboard. API still enforces adminAuth.
 */
function AdminRoute({ children }) {
  const navigate = useNavigate();
  const { hasAdminAccess, loading } = useAdminAuth();

  useEffect(() => {
    if (loading) {
      return;
    }
    if (hasAdminAccess) {
      return;
    }
    navigate('/', { replace: true });
  }, [loading, hasAdminAccess, navigate]);

  if (loading) {
    return null;
  }

  if (!hasAdminAccess) {
    return null;
  }

  return children;
}

export default AdminRoute;
